import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import SmHeader from "../../components/ForPages/SmHeader";
import HomeHeader from "../../components/ForPages/HomeHeader";
import Design from "../../components/ForPages/Design";
import Footer from "../../components/ForPages/Footer";
import { getForm } from "../../actions/forms";
import jwt_decode from "jwt-decode";
import { Redirect } from "react-router-dom";
import DesignPopup from "../../components/ForPages/DesignPopup";
import "./Home.css";
import CreativeCreateDesignForm from "../../components/userForms/CreativeCreateDesignForm";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../utils/config";
import { canvas_designs } from "../../utils/designsTypes";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./style.css";
SwiperCore.use([EffectCoverflow, Pagination]);

const CreativeHome = () => {
  const dispatch = useDispatch();

  document.body.style.backgroundColor = "#E5E4EF";
  const [showCreateDesignForm, setShowCreateDesignForm] = useState(false);

  const userToken = localStorage.getItem("skiUserToken");
  const [monthDownloadNbr, setMonthDownloadNumber] = useState(0),
    [totalDownloadNumber, setTotalDownloadNumber] = useState(0),
    [publishedTemplatesNbr, setPublishedTemplatesNbr] = useState(0),
    [savedTemplatesNbr, setSavedTemplatesNbr] = useState(0),
    [designViewsNumber, setDesignViewsNumber] = useState("7k"),
    [userRole, setUserRole] = useState("creative"),
    [designTitle, setDesignTitle] = useState(""),
    [popupDisplay, setPopupDisplay] = useState("none"),
    [activeID, setActiveID] = useState(null),
    changeDesignTitle = (v) => {
      setDesignTitle(v);
      setPopupDisplay("flex");
      document.body.style.overflow = "hidden";
    },
    [designs, setDesigns] = useState([]),
    history = useHistory();

  const deleteDesign = (id) => {
    axiosInstance
      .delete(`/creatives/designs/${id}/delete`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
        },
      })
      .then((res) => {
        let temp = designs.filter((x) => x._id !== id);
        setDesigns(temp);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    document.title = "Welcome to Ski Studio";
    if (userToken) {
      try {
        let decodedToken = jwt_decode(userToken);
        setUserRole(decodedToken.AccountType);
        if (decodedToken.AccountType !== "creative") history.push("/");
        else {
          axiosInstance
            .get("/user/templates/downloads", {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
              },
            })
            .then((res) => {
              setMonthDownloadNumber(res.data.monthlyDownloads);
              setTotalDownloadNumber(res.data.totalDownloads);
            })
            .catch((err) => console.error(err));
          axiosInstance
            .get("/user/templates/statistics", {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
              },
            })
            .then((res) => {
              console.log(res.data);
              setPublishedTemplatesNbr(res.data.publishedTemplates);
              setSavedTemplatesNbr(res.data.savedTemplates);
            })
            .catch((err) => console.error(err));
        }
      } catch (err) {
        history.push("/");
      }
    } else {
      localStorage.removeItem("skiUserToken");
      setUserRole("");
      history.push("/");
    }
  }, [userToken, history]);

  useEffect(() => {
    axiosInstance
      .get("/user/templates", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("skiUserToken")}`,
        },
      })
      .then((res) => {
        let temp_data = [];
        let user = jwt_decode(localStorage.getItem("skiUserToken"));
        res.data.data.slice(0, 20).map((t) => {
          let canva_design = canvas_designs.find((d) => d.value === t.Category);
          if (canva_design) {
            let new_t = {
              imgSrc: "/Images/groovinx.png",
              title: t.Name,
              type: t.Category,
              width: canva_design.width,
              height: canva_design.height,
              templateFile: t.templateFile,
              _id: t._id,
              CreatedBy: t.CreatedBy._id,
              published: t.isPublished,
            };

            temp_data.push(new_t);
          }
        });
        setDesigns(temp_data);
      })
      .catch((err) => console.log(err));
  }, []);
  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return (
    <>
      {showCreateDesignForm && <CreativeCreateDesignForm />}
      <div className="Home CreativeHome">
        {userRole !== "creative" && <Redirect to="/" />}
        <SmHeader />
        <HomeHeader tab="home" include="" />
        <div className="Middle-welcome">
          <h2>Welcome to Ski Creative Studio</h2>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => setShowCreateDesignForm(true)}
            onMouseOver={() => setShowCreateDesignForm(false)}
          >
            Create A Design
          </button>
          <button
            className="btn btn-primary shadow-sm text-white left "
            type="button"
            onClick={() => openInNewTab('https://ski-video-editor.netlify.app/#/')
            }
            onMouseOver={() => setShowCreateDesignForm(false)}
          >
            Create A Video
          </button>
        </div>
        <div className="creative-design-info">
          <div className="stats-container flex-sm-wrap align-items-center justify-content-center download-info">
            <h1 className="p-3">Stats</h1>
            <div className="flex-sm-wrap align-items-center justify-content-center">
              <div>
                <div>
                  <h3>{monthDownloadNbr} Downloads</h3>
                  <p>This Month</p>
                </div>
                <img src="./Images/green_cube.png" alt="Green cube" />
              </div>
              <div>
                <div>
                  <h3>{totalDownloadNumber} Downloads</h3>
                  <p>In Total</p>
                </div>
                <img src="./Images/orange_cube.png" alt="Orange cube" />
              </div>
              <div>
                <div>
                  <h3>{publishedTemplatesNbr} Templates</h3>
                  <p>Published</p>
                </div>
                <img src="./Images/green_cube.png" alt="Green cube" />
              </div>
              <div>
                <div>
                  <h3>{savedTemplatesNbr} Templates</h3>
                  <p>Saved</p>
                </div>
                <img src="./Images/orange_cube.png" alt="Orange cube" />
              </div>
            </div>
          </div>
          <div className="creative-designs-list">
            <h1 className="p-3">Created Designs</h1>
            <Swiper
              slidesPerView={1}
              spaceBetween={100}
              freeMode={true}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper"
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
              }}
            >
              {designs.map((design, index) => (
                <SwiperSlide>
                  <Design
                    key={index}
                    design={design}
                    changeDesignTitle={changeDesignTitle}
                    deleteDesign={deleteDesign}
                    setActiveID={setActiveID}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

          </div>
        </div>
        <Footer />
        <DesignPopup
          title={designTitle}
          display={popupDisplay}
          jwt_decode={jwt_decode}
          _id={activeID}
        />
      </div>
    </>
  );
};

export default CreativeHome;
